import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ProfileService } from '../services/profile.service';
import { UtilitiesService } from '../services/utilities.service';

interface ProfileResponse {
  profile?: {
    email?: string;
    role?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class ProfileResolver implements Resolve<ProfileResponse | null> {
  constructor(
    private profileService: ProfileService,
    private utilities: UtilitiesService
  ) { }

  resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<ProfileResponse | null> {
    return this.profileService.getProfile().pipe(
      tap((response: ProfileResponse) => {
        const role = response?.profile?.role ?? '';
        const demoRoles = ['demo_client_admin', 'demo_client_user'];
        const fdUsers = ['system_admin', 'fd_admin', 'fd_user'];
        const demoOnb = ['demo_client_admin_w_onboarding_wizard'];
        const acquirerUsers = ['acquirer_admin', 'acquirer_user'];

        this.utilities.setUserEmail(response?.profile?.email ?? '');
        this.utilities.setRole(role);
        this.utilities.setIsDemo(demoRoles.includes(role));
        this.utilities.setIsFdUser(fdUsers.includes(role));
        this.utilities.setIsDemoOnb(demoOnb.includes(role));
        this.utilities.setIsAcquirerUser(acquirerUsers.includes(role));
        // TODO: Replace with actual Nexio client detection from API
        // e.g. this.utilities.setIsNexioClient(response?.profile?.isNexioClient ?? false);
        this.utilities.setIsNexioClient(false);
      }),
      catchError(() => of(null))
    );
  }
}
